import { render, staticRenderFns } from "./review-link.vue?vue&type=template&id=3f991f36&scoped=true&"
import script from "./review-link.vue?vue&type=script&lang=js&"
export * from "./review-link.vue?vue&type=script&lang=js&"
import style0 from "./review-link.vue?vue&type=style&index=0&id=3f991f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f991f36",
  null
  
)

export default component.exports